import React, { useContext, useEffect, useState } from 'react';
import { FormControlLabel, FormHelperText, InputLabel } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {
    getAllVehicleCheckSectionDropDown,
    getInspectionSheetFieldTypes,
    getvehiclecheckchecksById,
    postvehiclecheckchecksData
} from '../../../Core/Service/vehicleChecks';
import { Multiselect, SecondaryButton, SecondaryCheckbox, SelectBox, TextBox } from '../../../Core/FormInput';
import CustomeEditor from '../../../Core/CkEditor';
import AppContext from '../../../App/AppContext';

const labelStyle = { marginBottom: '2px' };
const checkboxRowStyle = { paddingTop: '4px' };

const VehicleCheckCheckMdal = (props) => {
    const { showToast } = useContext(AppContext);
    const [btnLoader, setBtnLoader] = useState(false);
    const [state, setState] = useState({
        inspectionSheetCheckID: null,
        inspectionSheetCheckDescription: '',
        inspectionSheetSectionID: props.addID,
        inspectionSheetCheckPosition: '',
        inspectionSheetCheckLegalRequirement: false,
        inspectionSheetCheckActive: true,
        inspectionSheetCheckFreeTextField: false,
        inspectionSheetCheckCanHidePhotoUpload: false,
        inspectionSheetCheckCanHideDefectDescription: false,
        inspectionSheetCheckPhotoMandatoryOnfail: false,
        inspectionSheetIMReference: '',
        dropdownList: [],
        errors: {},
        categoryList: [],
        checkVehicleCategoryIDs: props.sectionVehicleCategoryIDs || [],
        inspectionSheetCheckInformation: '',
        inspectionSheetCheckFieldTypeID: '',
        // inspectionSheetCheckMakeVOROnFail: false,
        inspectionSheetCheckPhotoMandatory: false,
        fieldTypeList: [],
        inspectionList: [],
        inspectionSheetCheckListTypeID: ''
    });

    useEffect(() => {
        let fetchData = async () => {
            try {
                let fieldTypeList = [];
                let inspectionList = [];
                let fieldTypesRes = await getInspectionSheetFieldTypes();
                if (fieldTypesRes?.success) {
                    fieldTypeList = fieldTypesRes.data?.fieldTypes || [];
                    inspectionList = fieldTypesRes.data?.inspectionList || [];
                }

                setState((state) => ({
                    ...state,
                    fieldTypeList,
                    inspectionList
                }));

                if (props.checkUserID) {
                    let res = await getvehiclecheckchecksById(props.checkUserID);

                    let Data = res.data.details[0];
                    if (res.success) {
                        setState((state) => ({
                            ...state,
                            inspectionSheetCheckID: Data.inspectionSheetCheckID,
                            inspectionSheetSectionID: Data.inspectionSheetCheckSectionID,
                            inspectionSheetCheckDescription: Data.inspectionSheetCheckDescription,
                            inspectionSheetCheckPosition: Data.inspectionSheetCheckPosition,
                            inspectionSheetIMReference: Data.inspectionSheetIMReference,
                            inspectionSheetCheckLegalRequirement: Data.inspectionSheetCheckLegalRequirement,
                            inspectionSheetCheckActive: Data.inspectionSheetCheckActive,
                            checkVehicleCategoryIDs: res.data.checkVehicleCategoryIDs,
                            inspectionSheetCheckFreeTextField: Data.inspectionSheetCheckFreeTextField,
                            inspectionSheetCheckCanHidePhotoUpload: Data.inspectionSheetCheckCanHidePhotoUpload,
                            inspectionSheetCheckCanHideDefectDescription: Data.inspectionSheetCheckCanHideDefectDescription,
                            inspectionSheetCheckPhotoMandatoryOnfail: Data.inspectionSheetCheckPhotoMandatoryOnfail,
                            inspectionSheetCheckInformation: Data.inspectionSheetCheckInformation || '',
                            inspectionSheetCheckFieldTypeID: Data.inspectionSheetCheckFieldTypeID || '',
                            inspectionSheetCheckListTypeID: Data.inspectionSheetCheckListTypeID || '',
                            // inspectionSheetCheckMakeVOROnFail: Data.inspectionSheetCheckMakeVOROnFail || false,
                            inspectionSheetCheckPhotoMandatory: Data.inspectionSheetCheckPhotoMandatory || false,
                            fieldTypeList
                        }));
                    }
                }

                let res2 = await getAllVehicleCheckSectionDropDown();
                let list = res2?.data?.list || [];

                let FilterCategory = [];
                if (props.sectionVehicleCategoryIDs && props.sectionVehicleCategoryIDs.length > 0) {
                    FilterCategory = list.filter((item) => item && props.sectionVehicleCategoryIDs.includes(item.vehicleCategoryID));
                } else {
                    FilterCategory = list;
                }

                setState((state) => ({
                    ...state,
                    categoryList: (FilterCategory || []).filter(Boolean).map((item) => ({
                        id: item.vehicleCategoryID,
                        name: item.vehicleCategoryDescription
                    }))
                }));
            } catch (error) {
                console.warn(error);
            }
        };

        return fetchData();
    }, [props.checkUserID, props.sectionVehicleCategoryIDs]);

    useEffect(() => {
        function fetchData() {
            try {
                if (state.checkVehicleCategoryIDs) {
                    const filterVehCat = state.categoryList.filter((w) => state.checkVehicleCategoryIDs.indexOf(w.id) > -1);
                    setState((st) => ({ ...st, categoryID: filterVehCat }));
                }
            } catch (error) {
                console.warn(error);
            }
        }
        return fetchData();
    }, [state.checkVehicleCategoryIDs, state.categoryList]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState((state) => ({ ...state, [name]: value }));
    };

    const handleCkeditorstate = (name) => (event, editor) => {
        const data = editor.getData();
        setState((state) => ({ ...state, [name]: data }));
    };

    const handleCheckbox = (e) => {
        const { name, checked } = e.target;
        setState((state) => {
            let nst = { ...state, [name]: checked };
            if (name === 'inspectionSheetCheckPhotoMandatory' && checked) {
                nst.inspectionSheetCheckCanHidePhotoUpload = false;
            }
            return nst;
        });
    };

    let randerSelectAll = (type, name) => {
        if (type === 'SelectAll') {
            let AllData = [...state.categoryList];
            setState((st) => ({ ...st, categoryID: AllData, checkVehicleCategoryIDs: AllData.map((k) => k.id) }));
        }
        if (type === 'clear') {
            setState((st) => ({ ...st, categoryID: [], checkVehicleCategoryIDs: [] }));
        }
    };

    const validations = () => {
        const {
            inspectionSheetCheckDescription,
            inspectionSheetCheckPosition,
            checkVehicleCategoryIDs,
            inspectionSheetCheckFieldTypeID,
            inspectionSheetCheckListTypeID
        } = state;
        let formIsValid = true;
        let errors = {};
        if (!inspectionSheetCheckDescription) {
            errors.inspectionSheetCheckDescription = 'Description is required';
            formIsValid = false;
        }
        if (!inspectionSheetCheckPosition) {
            errors.inspectionSheetCheckPosition = 'Position is required';
            formIsValid = false;
        }
        if (checkVehicleCategoryIDs.length === 0) {
            errors.vehicleCategory = 'Vehicle Categories is required';
            formIsValid = false;
        }
        if (inspectionSheetCheckFieldTypeID === 'LT' && !inspectionSheetCheckListTypeID) {
            errors.inspectionSheetCheckListTypeID = 'List Type is required';
            formIsValid = false;
        }
        setState((state) => ({ ...state, errors: errors }));
        return formIsValid;
    };

    const ModuleChange = (e, value) => {
        setState((st) => {
            const nst = { ...st, checkVehicleCategoryIDs: value.map((c) => c.id), categoryID: value };
            return nst;
        });
    };

    const submitHandler = async () => {
        if (validations()) {
            setBtnLoader(true);
            try {
                let formData = {
                    inspectionSheetCheckID: state.inspectionSheetCheckID,
                    inspectionSheetCheckSectionID: state.inspectionSheetSectionID,
                    inspectionSheetCheckDescription: state.inspectionSheetCheckDescription,
                    inspectionSheetIMReference: state.inspectionSheetIMReference,
                    inspectionSheetCheckPosition: state.inspectionSheetCheckPosition,
                    inspectionSheetCheckLegalRequirement: state.inspectionSheetCheckLegalRequirement,
                    inspectionSheetCheckActive: state.inspectionSheetCheckActive,
                    checkVehicleCategoryIDs: state.checkVehicleCategoryIDs,
                    inspectionSheetSectionDescription: state.inspectionSheetSectionDescription,
                    inspectionSheetCheckFreeTextField: state.inspectionSheetCheckFreeTextField,
                    inspectionSheetCheckCanHidePhotoUpload: state.inspectionSheetCheckPhotoMandatory ? false : state.inspectionSheetCheckCanHidePhotoUpload,
                    inspectionSheetCheckCanHideDefectDescription: state.inspectionSheetCheckCanHideDefectDescription,
                    inspectionSheetCheckPhotoMandatoryOnfail: state.inspectionSheetCheckPhotoMandatoryOnfail,
                    inspectionSheetCheckInformation: state.inspectionSheetCheckInformation,
                    inspectionSheetCheckFieldTypeID: state.inspectionSheetCheckFieldTypeID,
                    // inspectionSheetCheckMakeVOROnFail: state.inspectionSheetCheckMakeVOROnFail,
                    inspectionSheetCheckPhotoMandatory: state.inspectionSheetCheckPhotoMandatory,
                    inspectionSheetCheckListTypeID: state.inspectionSheetCheckFieldTypeID == 'LT' ? state.inspectionSheetCheckListTypeID : null
                };
                let res = await postvehiclecheckchecksData(formData);
                if (res.success) {
                    showToast('Vehicle Check Checks Added Successfully');
                    props.onClose(true);
                } else {
                    showToast(res.message);
                }
            } catch (err) {
                showToast(err.message || 'Something went wrong');
            } finally {
                setBtnLoader(false);
            }
        }
    };

    return (
        <Grid container direction={'row'} spacing={2}>
            <Grid item xs={9} sm={10} md={10} lg={10} className="mandatory-fields">
                <InputLabel shrink required style={labelStyle}>
                    Description
                </InputLabel>
                <TextBox
                    name="inspectionSheetCheckDescription"
                    value={state.inspectionSheetCheckDescription}
                    onChange={handleInputChange}
                    autoFocus
                    placeholder="Description"
                />
                <FormHelperText error>{state.errors.inspectionSheetCheckDescription}</FormHelperText>
            </Grid>

            <Grid item xs={3} sm={2} md={2} lg={2} className="mandatory-fields">
                <InputLabel shrink required style={labelStyle}>
                    Position
                </InputLabel>
                <TextBox name="inspectionSheetCheckPosition" value={state.inspectionSheetCheckPosition} onChange={handleInputChange} />
                <FormHelperText error>{state.errors.inspectionSheetCheckPosition}</FormHelperText>
            </Grid>

            <Grid item xs={12}>
                <InputLabel shrink style={{ ...labelStyle, display: 'block', width: '100%' }}>
                    Additional Information
                </InputLabel>
                <CustomeEditor
                    data={state.inspectionSheetCheckInformation || ''}
                    onChange={handleCkeditorstate('inspectionSheetCheckInformation')}
                    placeholder="Additional Information"
                    name="inspectionSheetCheckInformation"
                />
            </Grid>

            <Grid item xs={12} className="mandatory-fields">
                <InputLabel required shrink style={labelStyle}>
                    Vehicle Categories
                </InputLabel>
                <Multiselect selectAll={randerSelectAll} options={state.categoryList || []} value={state.categoryID || []} onChange={ModuleChange} />
                <FormHelperText error>{state.errors.vehicleCategory}</FormHelperText>
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4}>
                <InputLabel shrink style={labelStyle}>
                    Field Type
                </InputLabel>
                <SelectBox
                    margin="dense"
                    List={state.fieldTypeList || []}
                    name="inspectionSheetCheckFieldTypeID"
                    value={state.inspectionSheetCheckFieldTypeID}
                    onChange={handleInputChange}
                />
                <FormHelperText error>{state.errors.inspectionSheetCheckFieldTypeID}</FormHelperText>
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} className={state.inspectionSheetCheckFieldTypeID === 'LT' ? 'mandatory-fields' : ''}>
                <InputLabel shrink required={state.inspectionSheetCheckFieldTypeID === 'LT'} style={labelStyle}>
                    List Type
                </InputLabel>
                <SelectBox
                    margin="dense"
                    List={state.inspectionList || []}
                    name="inspectionSheetCheckListTypeID"
                    value={state.inspectionSheetCheckListTypeID}
                    onChange={handleInputChange}
                    disabled={state.inspectionSheetCheckFieldTypeID !== 'LT'}
                />
                <FormHelperText error>{state.errors.inspectionSheetCheckListTypeID}</FormHelperText>
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4}>
                <InputLabel shrink style={labelStyle}>
                    IM Reference
                </InputLabel>
                <TextBox name="inspectionSheetIMReference" value={state.inspectionSheetIMReference} onChange={handleInputChange} placeholder="IM Reference" />
                <FormHelperText error>{state.errors.inspectionSheetIMReference}</FormHelperText>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={
                        <SecondaryCheckbox
                            checked={state.inspectionSheetCheckLegalRequirement}
                            onChange={handleCheckbox}
                            name="inspectionSheetCheckLegalRequirement"
                        />
                    }
                    label="Legal Requirement"
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={
                        <SecondaryCheckbox
                            checked={state.inspectionSheetCheckPhotoMandatory ? false : state.inspectionSheetCheckCanHidePhotoUpload}
                            onChange={handleCheckbox}
                            name="inspectionSheetCheckCanHidePhotoUpload"
                            disabled={state.inspectionSheetCheckPhotoMandatory}
                        />
                    }
                    label="Hide Photo Upload?"
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={
                        <SecondaryCheckbox
                            checked={state.inspectionSheetCheckPhotoMandatory}
                            onChange={handleCheckbox}
                            name="inspectionSheetCheckPhotoMandatory"
                        />
                    }
                    label="Photo Mandatory?"
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={
                        <SecondaryCheckbox
                            checked={state.inspectionSheetCheckCanHideDefectDescription}
                            onChange={handleCheckbox}
                            name="inspectionSheetCheckCanHideDefectDescription"
                        />
                    }
                    label="Hide Defect Description?"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={
                        <SecondaryCheckbox
                            checked={state.inspectionSheetCheckPhotoMandatoryOnfail}
                            onChange={handleCheckbox}
                            name="inspectionSheetCheckPhotoMandatoryOnfail"
                        />
                    }
                    label="Photo Mandatory On Fail"
                />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={
                        <SecondaryCheckbox
                            checked={state.inspectionSheetCheckMakeVOROnFail}
                            onChange={handleCheckbox}
                            name="inspectionSheetCheckMakeVOROnFail"
                        />
                    }
                    label="Make vehicle VOR on Fail"
                />
            </Grid> */}

            <Grid item xs={12} sm={6} md={4} lg={4} style={checkboxRowStyle}>
                <FormControlLabel
                    control={<SecondaryCheckbox checked={state.inspectionSheetCheckActive} onChange={handleCheckbox} name="inspectionSheetCheckActive" />}
                    label="Is Active?"
                />
            </Grid>

            <Grid item xs={12}>
                <Grid container spacing={2}>
                    <Grid item xs={6} className="submit_btn">
                        <SecondaryButton fullWidth onClick={submitHandler} disabled={btnLoader}>
                            {props.checkUserID ? 'Update' : 'Add'}
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={6} className="submit_btn">
                        <SecondaryButton fullWidth onClick={() => props.onClose()} disabled={btnLoader}>
                            Cancel
                        </SecondaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default VehicleCheckCheckMdal;
